import React from 'react';

import confetti from '@components/web/src/assets/gif/confetti.gif';
import * as S from '@components/web/src/atoms/Confetti/styles';

interface IProps {
  isVisible?: boolean;
  isShowBehind?: boolean;
}

const Confetti: React.FC<IProps> = ({ isVisible = true, isShowBehind = false }) => {
  if (!isVisible) return null;

  return (
    <S.ConfettiContainer $isShowBehind={isShowBehind}>
      <S.ImageWrapper alt="Confetti" src={confetti} />
    </S.ConfettiContainer>
  );
};

export default Confetti;
